import Axios from 'axios';

export const workersServiceAPI = Axios.create({
  baseURL: import.meta.env.VITE_WORKERS_SERVICE_API,
  headers: {
    Accept: 'application/json',
  },
});
